let regiones = [
  {
    idRegion: 1,
    nombreRegion: "DE TARAPACÁ",
    deprovs: [
      {
        idDeprov: 11,
        nombreDeprov: "Iquique",
        comunas: [
          {
            idComuna: 1107,
            nombreComuna: "ALTO HOSPICIO"
          },
          {
            idComuna: 1101,
            nombreComuna: "IQUIQUE"
          }
        ]
      },
      {
        idDeprov: 14,
        nombreDeprov: "Tamarugal",
        comunas: [
          {
            idComuna: 1402,
            nombreComuna: "CAMIÑA"
          },
          {
            idComuna: 1403,
            nombreComuna: "COLCHANE"
          },
          {
            idComuna: 1404,
            nombreComuna: "HUARA"
          },
          {
            idComuna: 1405,
            nombreComuna: "PICA"
          },
          {
            idComuna: 1401,
            nombreComuna: "POZO ALMONTE"
          }
        ]
      }
    ]
  },
  {
    idRegion: 2,
    nombreRegion: "DE ANTOFAGASTA",
    deprovs: [
      {
        idDeprov: 21,
        nombreDeprov: "Antofagasta",
        comunas: [
          {
            idComuna: 2101,
            nombreComuna: "ANTOFAGASTA"
          },
          {
            idComuna: 2302,
            nombreComuna: "MARÍA ELENA"
          },
          {
            idComuna: 2102,
            nombreComuna: "MEJILLONES"
          },
          {
            idComuna: 2103,
            nombreComuna: "SIERRA GORDA"
          },
          {
            idComuna: 2104,
            nombreComuna: "TALTAL"
          },
          {
            idComuna: 2301,
            nombreComuna: "TOCOPILLA"
          }
        ]
      },
      {
        idDeprov: 22,
        nombreDeprov: "El Loa",
        comunas: [
          {
            idComuna: 2201,
            nombreComuna: "CALAMA"
          },
          {
            idComuna: 2202,
            nombreComuna: "OLLAGÜE"
          },
          {
            idComuna: 2203,
            nombreComuna: "SAN PEDRO DE ATACAMA"
          }
        ]
      }
    ]
  },
  {
    idRegion: 3,
    nombreRegion: "DE ATACAMA",
    deprovs: [
      {
        idDeprov: 32,
        nombreDeprov: "Huasco - Vallenar",
        comunas: [
          {
            idComuna: 3302,
            nombreComuna: "ALTO DEL CARMEN"
          },
          {
            idComuna: 3303,
            nombreComuna: "FREIRINA"
          },
          {
            idComuna: 3304,
            nombreComuna: "HUASCO"
          },
          {
            idComuna: 3301,
            nombreComuna: "VALLENAR"
          }
        ]
      },
      {
        idDeprov: 31,
        nombreDeprov: "Copiapo - Chanaral",
        comunas: [
          {
            idComuna: 3102,
            nombreComuna: "CALDERA"
          },
          {
            idComuna: 3201,
            nombreComuna: "CHAÑARAL"
          },
          {
            idComuna: 3101,
            nombreComuna: "COPIAPÓ"
          },
          {
            idComuna: 3202,
            nombreComuna: "DIEGO DE ALMAGRO"
          },
          {
            idComuna: 3103,
            nombreComuna: "TIERRA AMARILLA"
          }
        ]
      }
    ]
  },
  {
    idRegion: 4,
    nombreRegion: "DE COQUIMBO",
    deprovs: [
      {
        idDeprov: 41,
        nombreDeprov: "Elqui",
        comunas: [
          {
            idComuna: 4103,
            nombreComuna: "ANDACOLLO"
          },
          {
            idComuna: 4102,
            nombreComuna: "COQUIMBO"
          },
          {
            idComuna: 4104,
            nombreComuna: "LA HIGUERA"
          },
          {
            idComuna: 4101,
            nombreComuna: "LA SERENA"
          },
          {
            idComuna: 4105,
            nombreComuna: "PAIHUANO"
          },
          {
            idComuna: 4106,
            nombreComuna: "VICUÑA"
          }
        ]
      },
      {
        idDeprov: 43,
        nombreDeprov: "Choapa",
        comunas: [
          {
            idComuna: 4202,
            nombreComuna: "CANELA"
          },
          {
            idComuna: 4201,
            nombreComuna: "ILLAPEL"
          },
          {
            idComuna: 4203,
            nombreComuna: "LOS VILOS"
          },
          {
            idComuna: 4204,
            nombreComuna: "SALAMANCA"
          }
        ]
      },
      {
        idDeprov: 42,
        nombreDeprov: "Limari",
        comunas: [
          {
            idComuna: 4302,
            nombreComuna: "COMBARBALÁ"
          },
          {
            idComuna: 4303,
            nombreComuna: "MONTE PATRIA"
          },
          {
            idComuna: 4301,
            nombreComuna: "OVALLE"
          },
          {
            idComuna: 4304,
            nombreComuna: "PUNITAQUI"
          },
          {
            idComuna: 4305,
            nombreComuna: "RÍO HURTADO"
          }
        ]
      }
    ]
  },
  {
    idRegion: 5,
    nombreRegion: "DE VALPARAÍSO",
    deprovs: [
      {
        idDeprov: 54,
        nombreDeprov: "San Antonio",
        comunas: [
          {
            idComuna: 5602,
            nombreComuna: "ALGARROBO"
          },
          {
            idComuna: 5603,
            nombreComuna: "CARTAGENA"
          },
          {
            idComuna: 5604,
            nombreComuna: "EL QUISCO"
          },
          {
            idComuna: 5605,
            nombreComuna: "EL TABO"
          },
          {
            idComuna: 5601,
            nombreComuna: "SAN ANTONIO"
          },
          {
            idComuna: 5606,
            nombreComuna: "SANTO DOMINGO"
          }
        ]
      },
      {
        idDeprov: 51,
        nombreDeprov: "Quillota - Petorca",
        comunas: [
          {
            idComuna: 5402,
            nombreComuna: "CABILDO"
          },
          {
            idComuna: 5503,
            nombreComuna: "HIJUELAS"
          },
          {
            idComuna: 5502,
            nombreComuna: "LA CALERA"
          },
          {
            idComuna: 5504,
            nombreComuna: "LA CRUZ"
          },
          {
            idComuna: 5401,
            nombreComuna: "LA LIGUA"
          },
          {
            idComuna: 5802,
            nombreComuna: "LIMACHE"
          },
          {
            idComuna: 5506,
            nombreComuna: "NOGALES"
          },
          {
            idComuna: 5803,
            nombreComuna: "OLMUÉ"
          },
          {
            idComuna: 5403,
            nombreComuna: "PAPUDO"
          },
          {
            idComuna: 5404,
            nombreComuna: "PETORCA"
          },
          {
            idComuna: 5501,
            nombreComuna: "QUILLOTA"
          },
          {
            idComuna: 5405,
            nombreComuna: "ZAPALLAR"
          }
        ]
      },
      {
        idDeprov: 52,
        nombreDeprov: "San Felipe - Los Andes",
        comunas: [
          {
            idComuna: 5302,
            nombreComuna: "CALLE LARGA"
          },
          {
            idComuna: 5702,
            nombreComuna: "CATEMU"
          },
          {
            idComuna: 5703,
            nombreComuna: "LLAILLAY"
          },
          {
            idComuna: 5301,
            nombreComuna: "LOS ANDES"
          },
          {
            idComuna: 5704,
            nombreComuna: "PANQUEHUE"
          },
          {
            idComuna: 5705,
            nombreComuna: "PUTAENDO"
          },
          {
            idComuna: 5303,
            nombreComuna: "RINCONADA"
          },
          {
            idComuna: 5304,
            nombreComuna: "SAN ESTEBAN"
          },
          {
            idComuna: 5701,
            nombreComuna: "SAN FELIPE"
          },
          {
            idComuna: 5706,
            nombreComuna: "SANTA MARÍA"
          }
        ]
      },
      {
        idDeprov: 53,
        nombreDeprov: "Valparaiso - Isla de Pascua",
        comunas: [
          {
            idComuna: 5102,
            nombreComuna: "CASABLANCA"
          },
          {
            idComuna: 5103,
            nombreComuna: "CONCÓN"
          },
          {
            idComuna: 5201,
            nombreComuna: "ISLA DE PASCUA"
          },
          {
            idComuna: 5104,
            nombreComuna: "JUAN FERNÁNDEZ"
          },
          {
            idComuna: 5105,
            nombreComuna: "PUCHUNCAVÍ"
          },
          {
            idComuna: 5801,
            nombreComuna: "QUILPUÉ"
          },
          {
            idComuna: 5107,
            nombreComuna: "QUINTERO"
          },
          {
            idComuna: 5101,
            nombreComuna: "VALPARAÍSO"
          },
          {
            idComuna: 5804,
            nombreComuna: "VILLA ALEMANA"
          },
          {
            idComuna: 5109,
            nombreComuna: "VIÑA DEL MAR"
          }
        ]
      }
    ]
  },
  {
    idRegion: 6,
    nombreRegion: "DEL LIBERTADOR BERNARDO OHIGGINS",
    deprovs: [
      {
        idDeprov: 62,
        nombreDeprov: "Colchagua",
        comunas: [
          {
            idComuna: 6302,
            nombreComuna: "CHÉPICA"
          },
          {
            idComuna: 6303,
            nombreComuna: "CHIMBARONGO"
          },
          {
            idComuna: 6304,
            nombreComuna: "LOLOL"
          },
          {
            idComuna: 6305,
            nombreComuna: "NANCAGUA"
          },
          {
            idComuna: 6306,
            nombreComuna: "PALMILLA"
          },
          {
            idComuna: 6307,
            nombreComuna: "PERALILLO"
          },
          {
            idComuna: 6308,
            nombreComuna: "PLACILLA"
          },
          {
            idComuna: 6309,
            nombreComuna: "PUMANQUE"
          },
          {
            idComuna: 6301,
            nombreComuna: "SAN FERNANDO"
          },
          {
            idComuna: 6310,
            nombreComuna: "SANTA CRUZ"
          }
        ]
      },
      {
        idDeprov: 61,
        nombreDeprov: "Cachapoal",
        comunas: [
          {
            idComuna: 6102,
            nombreComuna: "CODEGUA"
          },
          {
            idComuna: 6103,
            nombreComuna: "COINCO"
          },
          {
            idComuna: 6104,
            nombreComuna: "COLTAUCO"
          },
          {
            idComuna: 6105,
            nombreComuna: "DOÑIHUE"
          },
          {
            idComuna: 6106,
            nombreComuna: "GRANEROS"
          },
          {
            idComuna: 6107,
            nombreComuna: "LAS CABRAS"
          },
          {
            idComuna: 6108,
            nombreComuna: "MACHALÍ"
          },
          {
            idComuna: 6109,
            nombreComuna: "MALLOA"
          },
          {
            idComuna: 6110,
            nombreComuna: "MOSTAZAL"
          },
          {
            idComuna: 6111,
            nombreComuna: "OLIVAR"
          },
          {
            idComuna: 6112,
            nombreComuna: "PEUMO"
          },
          {
            idComuna: 6113,
            nombreComuna: "PICHIDEGUA"
          },
          {
            idComuna: 6114,
            nombreComuna: "QUINTA DE TILCOCO"
          },
          {
            idComuna: 6101,
            nombreComuna: "RANCAGUA"
          },
          {
            idComuna: 6115,
            nombreComuna: "RENGO"
          },
          {
            idComuna: 6116,
            nombreComuna: "REQUÍNOA"
          },
          {
            idComuna: 6117,
            nombreComuna: "SAN VICENTE"
          }
        ]
      },
      {
        idDeprov: 63,
        nombreDeprov: "Cardenal Caro",
        comunas: [
          {
            idComuna: 6202,
            nombreComuna: "LA ESTRELLA"
          },
          {
            idComuna: 6203,
            nombreComuna: "LITUECHE"
          },
          {
            idComuna: 6204,
            nombreComuna: "MARCHIHUE"
          },
          {
            idComuna: 6205,
            nombreComuna: "NAVIDAD"
          },
          {
            idComuna: 6206,
            nombreComuna: "PAREDONES"
          },
          {
            idComuna: 6201,
            nombreComuna: "PICHILEMU"
          }
        ]
      }
    ]
  },
  {
    idRegion: 7,
    nombreRegion: "DEL MAULE",
    deprovs: [
      {
        idDeprov: 74,
        nombreDeprov: "Cauquenes",
        comunas: [
          {
            idComuna: 7201,
            nombreComuna: "CAUQUENES"
          },
          {
            idComuna: 7202,
            nombreComuna: "CHANCO"
          },
          {
            idComuna: 7203,
            nombreComuna: "PELLUHUE"
          }
        ]
      },
      {
        idDeprov: 73,
        nombreDeprov: "Linares",
        comunas: [
          {
            idComuna: 7402,
            nombreComuna: "COLBÚN"
          },
          {
            idComuna: 7401,
            nombreComuna: "LINARES"
          },
          {
            idComuna: 7403,
            nombreComuna: "LONGAVÍ"
          },
          {
            idComuna: 7404,
            nombreComuna: "PARRAL"
          },
          {
            idComuna: 7405,
            nombreComuna: "RETIRO"
          },
          {
            idComuna: 7406,
            nombreComuna: "SAN JAVIER"
          },
          {
            idComuna: 7407,
            nombreComuna: "VILLA ALEGRE"
          },
          {
            idComuna: 7408,
            nombreComuna: "YERBAS BUENAS"
          }
        ]
      },
      {
        idDeprov: 72,
        nombreDeprov: "Talca",
        comunas: [
          {
            idComuna: 7102,
            nombreComuna: "CONSTITUCIÓN"
          },
          {
            idComuna: 7103,
            nombreComuna: "CUREPTO"
          },
          {
            idComuna: 7104,
            nombreComuna: "EMPEDRADO"
          },
          {
            idComuna: 7105,
            nombreComuna: "MAULE"
          },
          {
            idComuna: 7106,
            nombreComuna: "PELARCO"
          },
          {
            idComuna: 7107,
            nombreComuna: "PENCAHUE"
          },
          {
            idComuna: 7108,
            nombreComuna: "RÍO CLARO"
          },
          {
            idComuna: 7109,
            nombreComuna: "SAN CLEMENTE"
          },
          {
            idComuna: 7110,
            nombreComuna: "SAN RAFAEL"
          },
          {
            idComuna: 7101,
            nombreComuna: "TALCA"
          }
        ]
      },
      {
        idDeprov: 71,
        nombreDeprov: "Curico",
        comunas: [
          {
            idComuna: 7301,
            nombreComuna: "CURICÓ"
          },
          {
            idComuna: 7302,
            nombreComuna: "HUALAÑÉ"
          },
          {
            idComuna: 7303,
            nombreComuna: "LICANTÉN"
          },
          {
            idComuna: 7304,
            nombreComuna: "MOLINA"
          },
          {
            idComuna: 7305,
            nombreComuna: "RAUCO"
          },
          {
            idComuna: 7306,
            nombreComuna: "ROMERAL"
          },
          {
            idComuna: 7307,
            nombreComuna: "SAGRADA FAMILIA"
          },
          {
            idComuna: 7308,
            nombreComuna: "TENO"
          },
          {
            idComuna: 7309,
            nombreComuna: "VICHUQUÉN"
          }
        ]
      }
    ]
  },
  {
    idRegion: 8,
    nombreRegion: "DEL BIOBÍO",
    deprovs: [
      {
        idDeprov: 82,
        nombreDeprov: "Bio Bio",
        comunas: [
          {
            idComuna: 8314,
            nombreComuna: "ALTO BIOBÍO"
          },
          {
            idComuna: 8302,
            nombreComuna: "ANTUCO"
          },
          {
            idComuna: 8303,
            nombreComuna: "CABRERO"
          },
          {
            idComuna: 8304,
            nombreComuna: "LAJA"
          },
          {
            idComuna: 8301,
            nombreComuna: "LOS ÁNGELES"
          },
          {
            idComuna: 8305,
            nombreComuna: "MULCHÉN"
          },
          {
            idComuna: 8306,
            nombreComuna: "NACIMIENTO"
          },
          {
            idComuna: 8307,
            nombreComuna: "NEGRETE"
          },
          {
            idComuna: 8308,
            nombreComuna: "QUILACO"
          },
          {
            idComuna: 8309,
            nombreComuna: "QUILLECO"
          },
          {
            idComuna: 8310,
            nombreComuna: "SAN ROSENDO"
          },
          {
            idComuna: 8311,
            nombreComuna: "SANTA BÁRBARA"
          },
          {
            idComuna: 8312,
            nombreComuna: "TUCAPEL"
          },
          {
            idComuna: 8313,
            nombreComuna: "YUMBEL"
          }
        ]
      },
      {
        idDeprov: 84,
        nombreDeprov: "Arauco",
        comunas: [
          {
            idComuna: 8202,
            nombreComuna: "ARAUCO"
          },
          {
            idComuna: 8203,
            nombreComuna: "CAÑETE"
          },
          {
            idComuna: 8204,
            nombreComuna: "CONTULMO"
          },
          {
            idComuna: 8205,
            nombreComuna: "CURANILAHUE"
          },
          {
            idComuna: 8201,
            nombreComuna: "LEBU"
          },
          {
            idComuna: 8206,
            nombreComuna: "LOS ÁLAMOS"
          },
          {
            idComuna: 8207,
            nombreComuna: "TIRÚA"
          }
        ]
      },
      {
        idDeprov: 83,
        nombreDeprov: "Concepcion",
        comunas: [
          {
            idComuna: 8103,
            nombreComuna: "CHIGUAYANTE"
          },
          {
            idComuna: 8101,
            nombreComuna: "CONCEPCIÓN"
          },
          {
            idComuna: 8102,
            nombreComuna: "CORONEL"
          },
          {
            idComuna: 8104,
            nombreComuna: "FLORIDA"
          },
          {
            idComuna: 8112,
            nombreComuna: "HUALPÉN"
          },
          {
            idComuna: 8105,
            nombreComuna: "HUALQUI"
          },
          {
            idComuna: 8106,
            nombreComuna: "LOTA"
          },
          {
            idComuna: 8107,
            nombreComuna: "PENCO"
          },
          {
            idComuna: 8108,
            nombreComuna: "SAN PEDRO DE LA PAZ"
          },
          {
            idComuna: 8109,
            nombreComuna: "SANTA JUANA"
          },
          {
            idComuna: 8110,
            nombreComuna: "TALCAHUANO"
          },
          {
            idComuna: 8111,
            nombreComuna: "TOMÉ"
          }
        ]
      }
    ]
  },
  {
    idRegion: 9,
    nombreRegion: "DE LA ARAUCANÍA",
    deprovs: [
      {
        idDeprov: 91,
        nombreDeprov: "Malleco",
        comunas: [
          {
            idComuna: 9201,
            nombreComuna: "ANGOL"
          },
          {
            idComuna: 9202,
            nombreComuna: "COLLIPULLI"
          },
          {
            idComuna: 9203,
            nombreComuna: "CURACAUTÍN"
          },
          {
            idComuna: 9204,
            nombreComuna: "ERCILLA"
          },
          {
            idComuna: 9205,
            nombreComuna: "LONQUIMAY"
          },
          {
            idComuna: 9206,
            nombreComuna: "LOS SAUCES"
          },
          {
            idComuna: 9207,
            nombreComuna: "LUMACO"
          },
          {
            idComuna: 9208,
            nombreComuna: "PURÉN"
          },
          {
            idComuna: 9209,
            nombreComuna: "RENAICO"
          },
          {
            idComuna: 9210,
            nombreComuna: "TRAIGUÉN"
          },
          {
            idComuna: 9211,
            nombreComuna: "VICTORIA"
          }
        ]
      },
      {
        idDeprov: 92,
        nombreDeprov: "Cautin Norte",
        comunas: [
          {
            idComuna: 9102,
            nombreComuna: "CARAHUE"
          },
          {
            idComuna: 9121,
            nombreComuna: "CHOLCHOL"
          },
          {
            idComuna: 9103,
            nombreComuna: "CUNCO"
          },
          {
            idComuna: 9106,
            nombreComuna: "GALVARINO"
          },
          {
            idComuna: 9108,
            nombreComuna: "LAUTARO"
          },
          {
            idComuna: 9110,
            nombreComuna: "MELIPEUCO"
          },
          {
            idComuna: 9111,
            nombreComuna: "NUEVA IMPERIAL"
          },
          {
            idComuna: 9113,
            nombreComuna: "PERQUENCO"
          },
          {
            idComuna: 9116,
            nombreComuna: "SAAVEDRA"
          },
          {
            idComuna: 9101,
            nombreComuna: "TEMUCO"
          },
          {
            idComuna: 9119,
            nombreComuna: "VILCÚN"
          }
        ]
      },
      {
        idDeprov: 93,
        nombreDeprov: "Cautin Sur",
        comunas: [
          {
            idComuna: 9104,
            nombreComuna: "CURARREHUE"
          },
          {
            idComuna: 9105,
            nombreComuna: "FREIRE"
          },
          {
            idComuna: 9107,
            nombreComuna: "GORBEA"
          },
          {
            idComuna: 9109,
            nombreComuna: "LONCOCHE"
          },
          {
            idComuna: 9112,
            nombreComuna: "PADRE LAS CASAS"
          },
          {
            idComuna: 9114,
            nombreComuna: "PITRUFQUÉN"
          },
          {
            idComuna: 9115,
            nombreComuna: "PUCÓN"
          },
          {
            idComuna: 9117,
            nombreComuna: "TEODORO SCHMIDT"
          },
          {
            idComuna: 9118,
            nombreComuna: "TOLTÉN"
          },
          {
            idComuna: 9120,
            nombreComuna: "VILLARRICA"
          }
        ]
      }
    ]
  },
  {
    idRegion: 10,
    nombreRegion: "DE LOS LAGOS",
    deprovs: [
      {
        idDeprov: 102,
        nombreDeprov: "Chiloe",
        comunas: [
          {
            idComuna: 10202,
            nombreComuna: "ANCUD"
          },
          {
            idComuna: 10201,
            nombreComuna: "CASTRO"
          },
          {
            idComuna: 10203,
            nombreComuna: "CHONCHI"
          },
          {
            idComuna: 10204,
            nombreComuna: "CURACO DE VÉLEZ"
          },
          {
            idComuna: 10205,
            nombreComuna: "DALCAHUE"
          },
          {
            idComuna: 10206,
            nombreComuna: "PUQUELDÓN"
          },
          {
            idComuna: 10207,
            nombreComuna: "QUEILÉN"
          },
          {
            idComuna: 10208,
            nombreComuna: "QUELLÓN"
          },
          {
            idComuna: 10209,
            nombreComuna: "QUEMCHI"
          },
          {
            idComuna: 10210,
            nombreComuna: "QUINCHAO"
          }
        ]
      },
      {
        idDeprov: 101,
        nombreDeprov: "Llanquihue",
        comunas: [
          {
            idComuna: 10102,
            nombreComuna: "CALBUCO"
          },
          {
            idComuna: 10103,
            nombreComuna: "COCHAMÓ"
          },
          {
            idComuna: 10104,
            nombreComuna: "FRESIA"
          },
          {
            idComuna: 10105,
            nombreComuna: "FRUTILLAR"
          },
          {
            idComuna: 10403,
            nombreComuna: "HUALAIHUÉ"
          },
          {
            idComuna: 10107,
            nombreComuna: "LLANQUIHUE"
          },
          {
            idComuna: 10106,
            nombreComuna: "LOS MUERMOS"
          },
          {
            idComuna: 10108,
            nombreComuna: "MAULLÍN"
          },
          {
            idComuna: 10101,
            nombreComuna: "PUERTO MONTT"
          },
          {
            idComuna: 10109,
            nombreComuna: "PUERTO VARAS"
          }
        ]
      },
      {
        idDeprov: 104,
        nombreDeprov: "Palena",
        comunas: [
          {
            idComuna: 10401,
            nombreComuna: "CHAITÉN"
          },
          {
            idComuna: 10402,
            nombreComuna: "FUTALEUFÚ"
          },
          {
            idComuna: 10404,
            nombreComuna: "PALENA"
          }
        ]
      },
      {
        idDeprov: 103,
        nombreDeprov: "Osorno",
        comunas: [
          {
            idComuna: 10301,
            nombreComuna: "OSORNO"
          },
          {
            idComuna: 10302,
            nombreComuna: "PUERTO OCTAY"
          },
          {
            idComuna: 10303,
            nombreComuna: "PURRANQUE"
          },
          {
            idComuna: 10304,
            nombreComuna: "PUYEHUE"
          },
          {
            idComuna: 10305,
            nombreComuna: "RÍO NEGRO"
          },
          {
            idComuna: 10306,
            nombreComuna: "SAN JUAN DE LA COSTA"
          },
          {
            idComuna: 10307,
            nombreComuna: "SAN PABLO"
          }
        ]
      }
    ]
  },
  {
    idRegion: 11,
    nombreRegion: "DE AYSÉN DEL GENERAL CARLOS IBAÑEZ DEL CAMPO",
    deprovs: [
      {
        idDeprov: 111,
        nombreDeprov: "Coyhaique",
        comunas: [
          {
            idComuna: 11201,
            nombreComuna: "AYSÉN"
          },
          {
            idComuna: 11401,
            nombreComuna: "CHILE CHICO"
          },
          {
            idComuna: 11202,
            nombreComuna: "CISNES"
          },
          {
            idComuna: 11301,
            nombreComuna: "COCHRANE"
          },
          {
            idComuna: 11101,
            nombreComuna: "COYHAIQUE"
          },
          {
            idComuna: 11203,
            nombreComuna: "GUAITECAS"
          },
          {
            idComuna: 11102,
            nombreComuna: "LAGO VERDE"
          },
          {
            idComuna: 11302,
            nombreComuna: "O'HIGGINS"
          },
          {
            idComuna: 11402,
            nombreComuna: "RÍO IBÁÑEZ"
          },
          {
            idComuna: 11303,
            nombreComuna: "TORTEL"
          }
        ]
      }
    ]
  },
  {
    idRegion: 12,
    nombreRegion: "DE MAGALLANES Y DE LA ANTÁRTICA CHILENA",
    deprovs: [
      {
        idDeprov: 121,
        nombreDeprov: "Magallanes",
        comunas: [
          {
            idComuna: 12202,
            nombreComuna: "ANTÁRTICA"
          },
          {
            idComuna: 12201,
            nombreComuna: "CABO DE HORNOS"
          },
          {
            idComuna: 12102,
            nombreComuna: "LAGUNA BLANCA"
          },
          {
            idComuna: 12401,
            nombreComuna: "NATALES"
          },
          {
            idComuna: 12301,
            nombreComuna: "PORVENIR"
          },
          {
            idComuna: 12302,
            nombreComuna: "PRIMAVERA"
          },
          {
            idComuna: 12101,
            nombreComuna: "PUNTA ARENAS"
          },
          {
            idComuna: 12103,
            nombreComuna: "RÍO VERDE"
          },
          {
            idComuna: 12104,
            nombreComuna: "SAN GREGORIO"
          },
          {
            idComuna: 12303,
            nombreComuna: "TIMAUKEL"
          },
          {
            idComuna: 12402,
            nombreComuna: "TORRES DEL PAINE"
          }
        ]
      }
    ]
  },
  {
    idRegion: 13,
    nombreRegion: "METROPOLITANA DE SANTIAGO",
    deprovs: [
      {
        idDeprov: 135,
        nombreDeprov: "Talagante",
        comunas: [
          {
            idComuna: 13502,
            nombreComuna: "ALHUÉ"
          },
          {
            idComuna: 13503,
            nombreComuna: "CURACAVÍ"
          },
          {
            idComuna: 13602,
            nombreComuna: "EL MONTE"
          },
          {
            idComuna: 13603,
            nombreComuna: "ISLA DE MAIPO"
          },
          {
            idComuna: 13504,
            nombreComuna: "MARÍA PINTO"
          },
          {
            idComuna: 13501,
            nombreComuna: "MELIPILLA"
          },
          {
            idComuna: 13604,
            nombreComuna: "PADRE HURTADO"
          },
          {
            idComuna: 13605,
            nombreComuna: "PEÑAFLOR"
          },
          {
            idComuna: 13505,
            nombreComuna: "SAN PEDRO"
          },
          {
            idComuna: 13601,
            nombreComuna: "TALAGANTE"
          }
        ]
      },
      {
        idDeprov: 132,
        nombreDeprov: "Sur",
        comunas: [
          {
            idComuna: 13402,
            nombreComuna: "BUIN"
          },
          {
            idComuna: 13403,
            nombreComuna: "CALERA DE TANGO"
          },
          {
            idComuna: 13105,
            nombreComuna: "EL BOSQUE"
          },
          {
            idComuna: 13109,
            nombreComuna: "LA CISTERNA"
          },
          {
            idComuna: 13111,
            nombreComuna: "LA GRANJA"
          },
          {
            idComuna: 13116,
            nombreComuna: "LO ESPEJO"
          },
          {
            idComuna: 13404,
            nombreComuna: "PAINE"
          },
          {
            idComuna: 13401,
            nombreComuna: "SAN BERNARDO"
          },
          {
            idComuna: 13131,
            nombreComuna: "SAN RAMÓN"
          }
        ]
      },
      {
        idDeprov: 134,
        nombreDeprov: "Poniente",
        comunas: [
          {
            idComuna: 13102,
            nombreComuna: "CERRILLOS"
          },
          {
            idComuna: 13103,
            nombreComuna: "CERRO NAVIA"
          },
          {
            idComuna: 13106,
            nombreComuna: "ESTACIÓN CENTRAL"
          },
          {
            idComuna: 13117,
            nombreComuna: "LO PRADO"
          },
          {
            idComuna: 13119,
            nombreComuna: "MAIPÚ"
          },
          {
            idComuna: 13124,
            nombreComuna: "PUDAHUEL"
          },
          {
            idComuna: 13126,
            nombreComuna: "QUINTA NORMAL"
          },
          {
            idComuna: 13128,
            nombreComuna: "RENCA"
          }
        ]
      },
      {
        idDeprov: 137,
        nombreDeprov: "Norte",
        comunas: [
          {
            idComuna: 13301,
            nombreComuna: "COLINA"
          },
          {
            idComuna: 13104,
            nombreComuna: "CONCHALÍ"
          },
          {
            idComuna: 13107,
            nombreComuna: "HUECHURABA"
          },
          {
            idComuna: 13108,
            nombreComuna: "INDEPENDENCIA"
          },
          {
            idComuna: 13302,
            nombreComuna: "LAMPA"
          },
          {
            idComuna: 13125,
            nombreComuna: "QUILICURA"
          },
          {
            idComuna: 13127,
            nombreComuna: "RECOLETA"
          },
          {
            idComuna: 13303,
            nombreComuna: "TILTIL"
          }
        ]
      },
      {
        idDeprov: 136,
        nombreDeprov: "Cordillera",
        comunas: [
          {
            idComuna: 13110,
            nombreComuna: "LA FLORIDA"
          },
          {
            idComuna: 13112,
            nombreComuna: "LA PINTANA"
          },
          {
            idComuna: 13202,
            nombreComuna: "PIRQUE"
          },
          {
            idComuna: 13201,
            nombreComuna: "PUENTE ALTO"
          },
          {
            idComuna: 13203,
            nombreComuna: "SAN JOSÉ DE MAIPO"
          }
        ]
      },
      {
        idDeprov: 133,
        nombreDeprov: "Oriente",
        comunas: [
          {
            idComuna: 13113,
            nombreComuna: "LA REINA"
          },
          {
            idComuna: 13114,
            nombreComuna: "LAS CONDES"
          },
          {
            idComuna: 13115,
            nombreComuna: "LO BARNECHEA"
          },
          {
            idComuna: 13118,
            nombreComuna: "MACUL"
          },
          {
            idComuna: 13120,
            nombreComuna: "ÑUÑOA"
          },
          {
            idComuna: 13122,
            nombreComuna: "PEÑALOLÉN"
          },
          {
            idComuna: 13123,
            nombreComuna: "PROVIDENCIA"
          },
          {
            idComuna: 13132,
            nombreComuna: "VITACURA"
          }
        ]
      },
      {
        idDeprov: 131,
        nombreDeprov: "Centro",
        comunas: [
          {
            idComuna: 13121,
            nombreComuna: "PEDRO AGUIRRE CERDA"
          },
          {
            idComuna: 13129,
            nombreComuna: "SAN JOAQUÍN"
          },
          {
            idComuna: 13130,
            nombreComuna: "SAN MIGUEL"
          },
          {
            idComuna: 13101,
            nombreComuna: "SANTIAGO"
          }
        ]
      }
    ]
  },
  {
    idRegion: 14,
    nombreRegion: "DE LOS RÍOS",
    deprovs: [
      {
        idDeprov: 141,
        nombreDeprov: "Valdivia",
        comunas: [
          {
            idComuna: 14102,
            nombreComuna: "CORRAL"
          },
          {
            idComuna: 14103,
            nombreComuna: "LANCO"
          },
          {
            idComuna: 14104,
            nombreComuna: "LOS LAGOS"
          },
          {
            idComuna: 14106,
            nombreComuna: "MARIQUINA"
          },
          {
            idComuna: 14105,
            nombreComuna: "MÁFIL"
          },
          {
            idComuna: 14107,
            nombreComuna: "PAILLACO"
          },
          {
            idComuna: 14108,
            nombreComuna: "PANGUIPULLI"
          },
          {
            idComuna: 14101,
            nombreComuna: "VALDIVIA"
          }
        ]
      },
      {
        idDeprov: 142,
        nombreDeprov: "Ranco",
        comunas: [
          {
            idComuna: 14202,
            nombreComuna: "FUTRONO"
          },
          {
            idComuna: 14201,
            nombreComuna: "LA UNIÓN"
          },
          {
            idComuna: 14203,
            nombreComuna: "LAGO RANCO"
          },
          {
            idComuna: 14204,
            nombreComuna: "RÍO BUENO"
          }
        ]
      }
    ]
  },
  {
    idRegion: 15,
    nombreRegion: "DE ARICA Y PARINACOTA",
    deprovs: [
      {
        idDeprov: 151,
        nombreDeprov: "Arica",
        comunas: [
          {
            idComuna: 15101,
            nombreComuna: "ARICA"
          },
          {
            idComuna: 15102,
            nombreComuna: "CAMARONES"
          }
        ]
      },
      {
        idDeprov: 152,
        nombreDeprov: "Parinacota",
        comunas: [
          {
            idComuna: 15202,
            nombreComuna: "GENERAL LAGOS"
          },
          {
            idComuna: 15201,
            nombreComuna: "PUTRE"
          }
        ]
      }
    ]
  },
  {
    idRegion: 16,
    nombreRegion: "DE ÑUBLE",
    deprovs: [
      {
        idDeprov: 161,
        nombreDeprov: "Diguillín",
        comunas: [
          {
            idComuna: 16102,
            nombreComuna: "BULNES"
          },
          {
            idComuna: 16101,
            nombreComuna: "CHILLÁN"
          },
          {
            idComuna: 16103,
            nombreComuna: "CHILLÁN VIEJO"
          },
          {
            idComuna: 16202,
            nombreComuna: "COBQUECURA"
          },
          {
            idComuna: 16203,
            nombreComuna: "COELEMU"
          },
          {
            idComuna: 16302,
            nombreComuna: "COIHUECO"
          },
          {
            idComuna: 16104,
            nombreComuna: "EL CARMEN"
          },
          {
            idComuna: 16204,
            nombreComuna: "NINHUE"
          },
          {
            idComuna: 16303,
            nombreComuna: "ÑIQUÉN"
          },
          {
            idComuna: 16105,
            nombreComuna: "PEMUCO"
          },
          {
            idComuna: 16106,
            nombreComuna: "PINTO"
          },
          {
            idComuna: 16205,
            nombreComuna: "PORTEZUELO"
          },
          {
            idComuna: 16107,
            nombreComuna: "QUILLÓN"
          },
          {
            idComuna: 16201,
            nombreComuna: "QUIRIHUE"
          },
          {
            idComuna: 16206,
            nombreComuna: "RÁNQUIL"
          },
          {
            idComuna: 16301,
            nombreComuna: "SAN CARLOS"
          },
          {
            idComuna: 16304,
            nombreComuna: "SAN FABIÁN"
          },
          {
            idComuna: 16108,
            nombreComuna: "SAN IGNACIO"
          },
          {
            idComuna: 16305,
            nombreComuna: "SAN NICOLÁS"
          },
          {
            idComuna: 16207,
            nombreComuna: "TREGUACO"
          },
          {
            idComuna: 16109,
            nombreComuna: "YUNGAY"
          }
        ]
      }
    ]
  }
];

let getRegionesYComunas = function() {
  let data = regiones;
  let resultado = [];
  let region = {};
  let comunas = [];
  for (let r of data) {
    region = {};
    comunas = [];
    for (let d of r.deprovs) {
      comunas = comunas.concat(d.comunas);
    }
    region = {
      idRegion: r.idRegion,
      nombreRegion: r.nombreRegion,
      comunas: comunas
    };

    resultado.push(region);
  }
  return resultado;
};

//traduce comuna a valor por defecto para consulta a api-vitrina
let traduccionComunasApi = function(nombreComuna) {
  //remueve tildes
  let valor = nombreComuna.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  //se pasa a mayusculas
  valor = valor.toUpperCase();
  //se remueven espacios y transforman en underscores
  valor = valor.split(" ").join("_");
  //se remueven Ñ por N
  valor = valor.replace(/Ñ/, "N");
  //se remueven Ü por U
  valor = valor.replace(/Ü/, "U");
  //se remueven '
  valor = valor.replace(/'/, "");
  return valor;
};

export default {
  getRegionesYComunas,
  traduccionComunasApi
};



// WEBPACK FOOTER //
// ./src/services/ApiRegiones.js